import i18n from 'i18next';

import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetCurrencyList } from '../../hooks';

export const CurrencySelect = ({
  placeholder = i18n.t('translation:default.fields.currency.placeholder'),
  label = i18n.t('translation:default.fields.currency.label'),
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  tabIndex,
  disabled = false,
  dataTestId,
  isRequired = false,
}) => {
  const { data: options = [], isLoading } = useGetCurrencyList();

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      isRequired={isRequired}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      tabIndex={tabIndex}
      disabled={disabled}
      dataTestId={dataTestId || 'currency-selector'}
    />
  );
};
